import base from "../httpApi/base"; // 导入接口域名列表
import axios from "../httpApi/http"; // 导入http中创建的axios实例
const medalApi = {
  excelUrl: `${base.dev}/services/app/AdminEventMedal/Excel`,

  GetAllList(params) {
    return axios.get(`${base.dev}/services/app/AdminEventMedal/GetAllList`, {
      params
    });
  },
  Create(params) {
    return axios.post(
      `${base.dev}/services/app/AdminEventMedal/Create`,
      params
    );
  },
  AdminEventMedalDelete(params) {
    return axios.delete(`${base.dev}/services/app/AdminEventMedal/Delete`, {
      params
    });
  },
  Get(params) {
    return axios.get(`${base.dev}/services/app/AdminEventMedal/Get`, {
      params
    });
  },
  GetEventMedalsUsersList(params) {
    return axios.get(
      `${base.dev}/services/app/AdminEventMedal/GetEventMedalsUsersList`,
      {
        params
      }
    );
  },
  GetEventMedalsUsersById(params) {
    return axios.get(
      `${base.dev}/services/app/AdminEventMedal/GetEventMedalsUsersById`,
      {
        params
      }
    );
  },
  AddEventMedalsUser(params) {
    return axios.post(
      `${base.dev}/services/app/AdminEventMedal/AddEventMedalsUser`,
      params
    );
  },
  Excel(params) {
    return axios.post(`${base.dev}/services/app/AdminEventMedal/Excel`, params);
  },
  GetAll(params) {
    return axios.get(`${base.dev}/services/app/AdminEventMedal/GetAll`, {
      params
    });
  },
  Update(params) {
    return axios.put(`${base.dev}/services/app/AdminEventMedal/Update`, params);
  },
  Delete(params) {
    return axios.delete(`${base.dev}/services/app/AdminEventMedal/Delete`, {
      params
    });
  },
  /**
   * @description : 添加獎牌
   */
  CreateMedal(params) {
    return axios.post(
      `${base.dev}/services/app/AdminEventMedal/Create`,
      params
    );
  },
  UpdateEventMedalsUser(params) {
    return axios.put(
      `${base.dev}/services/app/AdminEventMedal/UpdateEventMedalsUser`,
      params
    );
  },
  DeleteMedalsUsers(params) {
    return axios.get(
      `${base.dev}/services/app/AdminEventMedal/DeleteMedalsUsers`,
      { params }
    );
  },
  /**
   * @description : 添加用戶點數
   */
  ManagementAdd(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPointManagement/Add`,
      params
    );
  },
  /**
   * @description : 列表
   */
  ManagementGetAllList(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPointManagement/GetAllList`,
      { params }
    );
  },
  /**
   * @description : 批量導入 格式： "行號", "用戶ID", "標題", "點數", "動作原因", "動作類型"
   */
  ManagementAddExcel(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPointManagement/AddExcel`,
      params
    );
  },
  /**
   * @description : 添加配置
   */
  AddSystemSetting(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPointManagement/AddSystemSetting`,
      params
    );
  },
  /**
   * @description : 添加配置
   */
  getSystemSettingList(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPointManagement/getSystemSettingList`,

      params
    );
  },
  //修改系統配置
  UpdateSystemSetting(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPointManagement/UpdateSystemSetting`,
      params
    );
  },
  //修改系統配置
  DeleteSystemSetting(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPointManagement/DeleteSystemSetting`,
      { params }
    );
  },
  GetSystemSetting(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPointManagement/GetSystemSetting`,
      { params }
    );
  },
  AdminSystemActivityToJson(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/ToJson`,
      params
    );
  },
  AdActivityGetSubmitFrom(params) {
    return axios.get(
      `${base.dev}/services/app/AdminSystemActivity/GetSubmitFrom`,
      { params }
    );
  },
  AdActivityDeleteSubmitFrom(params) {
    return axios.get(
      `${base.dev}/services/app/AdminSystemActivity/DeleteSubmitFrom`,
      { params }
    );
  },
  AdActivityUpdateSubmitFrom(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/UpdateSubmitFrom`,
      params
    );
  },
  SystemActivityToJson(params) {
    return axios.post(`${base.dev}/services/app/SystemActivity/ToJson`, params);
  },
  //點數兌換/發出總量
  PointManagementCount(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPointManagement/PointManagementCount`,
      params
    );
  },
  // 各分類發出總點數
  SendPointManagementCount(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPointManagementCount/SendPointManagementCount`,
      params
    );
  },
  //獲取最高用戶點數
  GetTopUser(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPointManagementCount/GetTopUser`,
      { params }
    );
  },
  //動作原因
  GetEnumsLists(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPointManagement/GetEnumsLists`,
      { params }
    );
  },
  //動作類型
  GetEnumsLists2(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPointManagement/GetEnumsLists2`,
      { params }
    );
  },
  GetSubmitTitle(params) {
    return axios.get(
      `${base.dev}/services/app/AdminSystemActivity/GetSubmitTitle`,
      {
        params
      }
    );
  },
  GetSubmitFromListById(params) {
    return axios.get(
      `${base.dev}/services/app/AdminSystemActivity/GetSubmitFromListById`,
      {
        params
      }
    );
  },
  AdminSystemActivityCreate(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/Create`,
      params
    );
  },
  CreateSubmitFrom(params) {
    return axios.post(
      `${base.dev}/services/app/SystemActivity/CreateSubmitFrom`,
      params
    );
  },
  SystemActivityGet(params) {
    return axios.get(`${base.dev}/services/app/SystemActivity/Get`, { params });
  },
  SystemActivityDraw(params) {
    return axios.get(`${base.dev}/services/app/SystemActivity/Draw`, {
      params
    });
  },
  GetQuestionsList(params) {
    return axios.get(
      `${base.dev}/services/app/AdminSystemActivity/GetQuestionsList`,
      { params }
    );
  },
  CreateQuestions(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/CreateQuestions`,
      params
    );
  },
  AdminSystemGetAll(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/GetAll`,
      params
    );
  },
  AdminSystemGet(params) {
    return axios.get(`${base.dev}/services/app/AdminSystemActivity/Get`, {
      params
    });
  },
  AdminSystemUpdate(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/Update`,
      params
    );
  },
  AdminSystemActivityDelete(params) {
    return axios.get(`${base.dev}/services/app/AdminSystemActivity/Delete`, {
      params
    });
  },
  //得到所有換領獎品類型
  PrizeNameGetEnumsLists(params) {
    return axios.get(`${base.dev}/services/app/AdminPrizeName/GetEnumsLists`, {
      params
    });
  },
  //更改状态&退回，退回的状态下不可以在显示按钮 调用接口
  UpdateStatus(params) {
    return axios.get(`${base.dev}/services/app/AdminPrizeName/UpdateStatus`, {
      params
    });
  },
  // PrizeNameGetEnumsLists(params) {
  //   return axios.get(`${base.dev}/services/app/AdminPrizeName/GetEnumsLists`, {
  //     params
  //   });
  // },
  //獲得所有用户兑换的獎品列表
  PrizeGetUsersAll(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPrizeName/GetUsersAll`,
      params
    );
  },
  ExcelQuestions(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/ExcelQuestions`,
      params
    );
  },
  UpdateQuestions(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/UpdateQuestions`,
      params
    );
  },
  DeleteQuestions(params) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/DeleteQuestions`,
      params
    );
  },
  //獲得獎品列表
  AdminPrizeNameGetAll(params) {
    return axios.get(`${base.dev}/services/app/AdminPrizeName/GetAll`, {
      params
    });
  },
  //修改獎品信息
  AdminPrizeNameUpdate(params) {
    return axios.post(`${base.dev}/services/app/AdminPrizeName/Update`, params);
  },
  //刪除獎品
  AdminPrizeNameDelete(params) {
    return axios.post(`${base.dev}/services/app/AdminPrizeName/Delete`, params);
  },
  //獲得單個獎品
  AdminPrizeNameGet(params) {
    return axios.get(`${base.dev}/services/app/AdminPrizeName/Get`, {
      params
    });
  },
  //新增獎品
  AdminPrizeNameCreate(params) {
    return axios.post(`${base.dev}/services/app/AdminPrizeName/Create`, params);
  },
  //導入獎品
  AdminPrizeNameExcel(params) {
    return axios.post(`${base.dev}/services/app/AdminPrizeName/Excel`, params);
  },
  //導出參加名單
  UpgradeReport(params,config) {
    return axios.post(
      `${base.dev}/services/app/AdminSystemActivity/UpgradeReport`,params,config);
  },
  //获取当前活动可以兑换的奖品列表
  GetActivityPrizeList(params) {
    return axios.get(
      `${base.dev}/services/app/SystemActivity/GetActivityPrizeList`,
      { params }
    );
  },
  //前台兑换奖品功能
  RedeemPrizes(params) {
    return axios.post(
      `${base.dev}/services/app/SystemActivity/RedeemPrizes`,
      params
    );
  },
  //或許當前用戶最新一條流水
  SystemActivityFirst(params) {
    return axios.post(`${base.dev}/services/app/SystemActivity/First`, params);
  }
};

export default medalApi;



// WEBPACK FOOTER //
// ./src/api/admedal/medalApi.js